window._define('class/Queue', ['jquery'], function ($) { 'use strict';

    var Queue = function (callback, options) {
        this.options = options || {};

        this.options = $.extend({
            delay: 1000,
            processWhenHidden: false,
        }, options || {});

        this.isProcessing = false;
        this.items = [];
        this.callback = callback;

        document.addEventListener('visibilitychange', $.proxy(this._handleVisibilityChange, this), false);
    };

    Queue.prototype._handleVisibilityChange = function _handleVisibilityChange() {
        if (this._canProcess()) {
            this._process();
        }
    };

    Queue.prototype.add = function add(event) {
        if (Array.isArray(event)) {
            this.items = this.items.concat(event);
        } else {
            this.items.push(event);
        }

        if (this._canProcess()) {
            this._process();
        }
    };

    Queue.prototype._process = function _process() {
        var self = this,
            item;

        item = this.items.shift();

        if (item) {
            this.isProcessing = true;
            this.callback(item, function () {
                setTimeout($.proxy(self._process, self), self.options.delay);
            });
        } else {
            this.isProcessing = false;
        }
    };

    Queue.prototype._canProcess = function _canProcess() {
        var processWhenHidden = this.options.processWhenHidden,
            canProcess = processWhenHidden || !(processWhenHidden || document.hidden),
            hasItems = this.items.length;

        return (canProcess && hasItems && !this.isProcessing);
    };

    return Queue;
});
